import { css } from '@compiled/react';

import { Button } from '@/libraries/design/components/button/src/button';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { useSiteActivationContext } from '../../hooks/site-activation-context';

export const SubmitButton = ({ submitMessage }: { submitMessage: string }) => {
	const { isSubmitting, hasSubmitted } = useSiteActivationContext();
	const visualFeedback = checkFeatureFlagGate(featureFlags.signupVisualAlignmentFeedback);
	return (
		<Button
			css={[buttonCss, visualFeedback && buttonVisualFeedbackCss]}
			type="submit"
			isDisabled={isSubmitting || hasSubmitted}
			isLoading={isSubmitting || hasSubmitted}
		>
			{submitMessage}
		</Button>
	);
};

const buttonCss = css({
	fontFamily: 'inherit',
	fontSize: 16,
	maxWidth: 'auto',
	paddingBlock: 8,
	width: '100%',
});

const buttonVisualFeedbackCss = css({
	borderRadius: 6,
	fontSize: 14,
});
